export default __webpack_public_path__ + "static/wbtw-meta-5333e23e874d4cbe263816b770761e48.png";